export const calcularValorComDesconto = (tipo = 'VALOR', valor = 0, valorDesconto = 0) => {
  let valorComDesconto = valor;

  if (tipo === 'VALOR') {
    valorComDesconto = valor - valorDesconto;
  } else if (tipo === 'PERCENTUAL') {
    const porcentagem = (valorDesconto || 0) / 100;

    const desconto = valor * porcentagem;

    valorComDesconto = valor - desconto;
  } else {
    throw new Error('Tipo deve ser "VALOR" ou "PERCENTUAL"');
  }

  return valorComDesconto;
};

export const getCurrency = (value) => {
  if (value === null || value === undefined) {
    return '';
  }
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

export const getCurrencySemSinalMonetario = (value, maximumFractionDigits) => {
  if (value === null || value === undefined) {
    return '';
  }
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits })
    .format(value)
    .replace('R$', '')
    .trim();
};
